<template>
  <div class="route-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        size="small"
        class="query-middle"
      >
        <el-form-item label="线路名称：">
          <el-input v-model="query.Name"></el-input>
        </el-form-item>
        <el-form-item label="创建时间：" style="margin-left: 20px">
          <el-date-picker
            v-model="query.StartTime"
            type="date"
            style="width: 200px"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="—">
          <el-date-picker
            v-model="query.EndTime"
            type="date"
            style="width: 200px"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" icon="el-icon-search" @click="getRoutes"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            icon="el-icon-circle-close"
            @click="resetForm('queryForm')"
            >清除</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i>线路列表 </span>
          <el-button-group>
            <router-link :to="{ path: '/route-input' }">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-circle-plus-outline"
                >新增</el-button
              >
            </router-link>
          </el-button-group>
        </div>
        <div class="left-table">
          <el-table
            :data="tableData"
            v-loading="loadingTable"
            height="753px"
            border
            style="width: 100%"
            :default-sort="{ prop: 'ApplyTime', order: 'descending' }"
          >
            <el-table-column
              type="selection"
              min-width="10"
              align="center"
            ></el-table-column>
            <el-table-column
              label="线路名称"
              prop="Name"
              min-width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="创建时间"
              prop="ApplyTime"
              min-width="140"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.ApplyTime | dateFormat }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="游玩天数"
              prop="DayCount"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              label="状态"
              prop="Status"
              min-width="90"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Status | keyToVal(statusType)"
                  effect="dark"
                  size="small"
                  >{{ scope.row.Status | keyToVal(lineStatus) }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-button
                    size="mini"
                    type="primary"
                    v-on:click="getDetail(scope.row)"
                    >查看</el-button
                  >
                  <el-popconfirm
                    title="确认删除吗？"
                    v-on:onConfirm="deleteRoute(scope.row)"
                    v-if="scope.row.orderCount==0 && scope.row.Status!=2 "
                  >
                    <el-button size="mini" type="danger" slot="reference"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="query.total"
            :page-size="query.PageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="query.PageIndex"
            v-on:size-change="handlePageSize"
            v-on:current-change="handlePageIndex"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span> <i class="el-icon-document"></i> 查看 </span>
          <el-button-group>
            <el-button
              type="warning"
              v-show="flag === 1 && IsOrderCount==0  && detail.Status!='2' "
              size="mini"
              @click="edit"
              >编辑</el-button
            >
            <el-button
              type="success"
              v-show="flag === 2"
              size="mini"
              @click="submitForm('updateForm')"
              >保存</el-button
            >
          </el-button-group>
        </div>
        <div class="right-table">
          <table class="input-form" v-show="flag === 1" v-loading="loadingLook">
            <thead>
              <tr>
                <th colspan="4">线路详情（查看）</th>
              </tr>
              <tr style="height: 41px">
                <td>线路名称</td>
                <td style="background: #fff">{{ detail.Name }}</td>
                <td>线路描述</td>
                <td style="background: #fff"><el-input v-model="detail.Describe" readonly></el-input></td>
                <!-- <td style="background: #fff">{{ detail.Describe }}</td> -->
              </tr>
              <tr style="height: 41px">
                <td>餐厅名称</td>
                <td style="background: #fff">{{ detail.RestaurantName }}</td>
                <td>餐饮价格（元）</td>
                <td style="background: #fff">{{ detail.RestaurantPrice }}</td>
              </tr>
              <tr style="height: 41px">
                <td>成人价格（元）</td>
                <td style="background: #fff">{{ detail.AdultPrice }}</td>
                <td>儿童价格（元）</td>
                <td style="background: #fff">{{ detail.ChildrenPrice }}</td>
              </tr>
              <tr style="height: 41px">
                <td>老年人价格（元）</td>
                <td style="background: #fff">{{ detail.ElderlyPrice }}</td>
                <td>产品编号</td>
                <td style="background: #fff">{{detail.ProductNumber}}</td>
              </tr>
              <div class="subtable-tab">
                <div
                  v-for="(item, index) in table"
                  :key="index"
                  class="mouse-pointer tab-item"
                  :class="{ 'sub-selected': currentSubId === item.id }"
                  @click="handleSubtable('switch', item.id)"
                >
                  <div>第{{ item.id + 1 }}天</div>
                </div>
              </div>
              <tr style="height: 45px"></tr>
            </thead>
            <tbody>
              <tr>
                <td>行程项目</td>
                <td colspan="2">行程时间</td>
                <td>行程类型</td>
              </tr>
              <tr
                v-for="(item, index) in table[currentSubId].arrangement"
                :key="index + 1"
              >
                <td>{{ item.Projects }}</td>
                <td colspan="2">{{ item.Time[0] + " 至 " + item.Time[1] }}</td>
                <!-- <td colspan="2">{{ item.StartTime + " 至 " + item.EndTime }}</td> -->
                <td>{{ item.PointId | getProjectType(options.projects) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="input-table" v-show="flag === 2">
            <table class="input-form">
              <thead>
                <tr>
                  <th colspan="4">线路详情（修改）</th>
                </tr>
                <tr>
                  <td>线路名称</td>
                  <td>
                    <el-input
                      v-model="detail.Name"
                      placeholder="请输入线路名称"
                    ></el-input>
                  </td>
                  <td>线路描述</td>
                  <td>
                    <el-input
                      v-model="detail.Describe"
                      placeholder="请输入线路描述"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <td>餐厅名称</td>
                  <td>
                    <el-input
                      v-model="detail.RestaurantName"
                      placeholder="请输入餐厅名称"
                    ></el-input>
                  </td>
                  <td>餐饮价格（元）</td>
                  <td>
                    <el-input-number
                      v-model="detail.RestaurantPrice"
                      :precision="2"
                      :min="0"
                    ></el-input-number>
                  </td>
                </tr>
                <tr>
                  <td>成人价格（元）</td>
                  <td>
                    <el-input-number
                      v-model="detail.AdultPrice"
                      :precision="2"
                      :min="0"
                    ></el-input-number>
                  </td>
                  <td>儿童价格（元）</td>
                  <td>
                    <el-input-number
                      v-model="detail.ChildrenPrice"
                      :precision="2"
                      :min="0"
                    ></el-input-number>
                  </td>
                </tr>
                <tr>
                  <td>老年人价格（元）</td>
                  <td>
                    <el-input-number
                      v-model="detail.ElderlyPrice"
                      :precision="2"
                      :min="0"
                    ></el-input-number>
                  </td>
                  <td>产品编号</td>
                  <td>
                    <el-input
                      v-model="detail.ProductNumber"
                      placeholder="请输入产品编号"
                    ></el-input>
                  </td>
                </tr>
                <div class="subtable-tab">
                  <div
                    v-for="(item, index) in table"
                    :key="index"
                    class="mouse-pointer tab-item"
                    :class="{ 'sub-selected': currentSubId === item.id }"
                    @click="handleSubtable('switch', item.id)"
                  >
                    <div>第{{ item.id + 1 }}天</div>
                  </div>
                  <div class="subtable-handle">
                    <el-button-group>
                      <el-button type="plain" @click="handleSubtable('plus')"
                        >＋</el-button
                      >
                      <el-button type="plain" @click="handleSubtable('minus')"
                        >﹣</el-button
                      >
                    </el-button-group>
                  </div>
                </div>
                <tr style="height: 45px"></tr>
              </thead>
              <tbody>
                <tr>
                  <td>行程项目</td>
                  <td colspan="2">行程时间</td>
                  <td>行程类型</td>
                </tr>
                <tr
                  v-for="(item, index) in table[currentSubId].arrangement"
                  :key="index + 1"
                >
                  <td>
                    <el-select v-model="item.PointId" placeholder="请选择" filterable >
                      <el-option
                        v-for="pro in options.projects"
                        :key="pro.Id"
                        :label="pro.ProjectName"
                        :value="pro.Id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td colspan="2">
                    <el-time-picker
                      is-range
                      :clearable="false"
                      v-model="item.Time"
                      range-separator="至"
                      format="HH:mm"
                      value-format="HH:mm"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      placeholder="选择时间范围"
                    ></el-time-picker>
                  </td>
                  <td>
                    {{ item.PointId | getProjectType(options.projects) }}
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <el-button-group>
                      <el-button
                        type="primary"
                        size="mini"
                        @click="handleArrangement('plus')"
                        >继续添加</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="handleArrangement('minus')"
                        >删除行</el-button
                      >
                    </el-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { keyToVal, dateFormat } from "@/filters/filters";
import { ValidationObserver } from "vee-validate";
import ValidationProvider from "@/common/vee-validator";

import { mapState } from "vuex";
import ROUTE from "@/api/route";
export default {
  name: "RouteManage",
  data() {
    return {
      query: {
        Name: "",
        StartTime: "",
        EndTime: "",
        total: 0,
        PageSize: 10,
        PageIndex: 1,
      },

      startTime: "",
      timerIndex: 1,

      //左边列表
      tableData: [],
      flag: 0, //0初始化 1查看状态（编辑显示） 2编辑状态（保存显示）
      currentSubId: 0,
      table: [
        {
          id: 0,
          arrangement: [],
        },
      ],

      config: {
        Name: "线路名称",
        RestaurantPrice: "餐饮价格",
        AdultPrice: "成人价格",
        ChildrenPrice: "儿童价格",
        ElderlyPrice: "老年人价格",
      },

      detail: {
        lineId: "",
        Name: "",
        Describe: "",
        RestaurantName: "", //餐厅名称
        RestaurantPrice: 0, //餐饮价格
        AdultPrice: 0, //成人价格
        ChildrenPrice: 0, //儿童价格
        ElderlyPrice: 0,
        lstLineDetails: [], //游客信息表
        Status:"",
        ProductNumber:"",
      },

      IsOrderCount:0,

      linePointFlag: {
        flag: false,
        day: 0,
        point: 0,
      },

      loadingTable:false,
      loadingLook:false,
    };
  },
  computed: {
    ...mapState("trip", {
      options: (state) => {
        return { projects: state.projects };
      },
    }),
    ...mapState("common", ["normalStatus", "statusType","lineStatus"]),
  },
  filters: {
    keyToVal,
    dateFormat,
    getProjectType(value, projects) {
      for (const pro of projects) {
        if (pro.Id == value) {
          return pro.Type;
        }
      }
      return "";
    },
  },
  methods: {
    //获取线路列表
    getRoutes() {
      var _self = this;
      _self.loadingTable=true;
      ROUTE.listRoutes(_self.query).then((res) => {
        if (res.status === "success") {
          _self.query.total = res.content.Total;
          _self.tableData = res.content.OnePageData;
        } else {
          _self.$message.error("列表获取失败!");
        }
        _self.loadingTable=false;
      });
    },
    //获取项目名
    getProjectName(id) {
      for (const pro of this.options.projects) {
        if (pro.Id == id) {
          return pro.ProjectName;
        }
      }
      return "";
    },
    submitForm(formName) {
      var _self = this;

      if (_self.linePointFlag.flag) {
        _self.$message.error(
          "第" +
            _self.linePointFlag.day +
            "天的第" +
            _self.linePointFlag.point +
            "个景点时间范围错误请修改"
        );
        return;
      }

      for (var key in _self.detail) {
        if (
          (_self.detail[key] == undefined || _self.detail[key].toString().trim().length == 0) &&
          _self.config[key] != undefined
        ) {
          _self.$message.error(_self.config[key] + '未填写');
          return
        }
      }

      //准备参数
      _self.detail.lstLineDetails = [];
      _self.table.forEach((v) => {
        let obj = { DayLineDetails: [] };
        v.arrangement.forEach((a) => {
          obj.DayLineDetails.push({
            PointId: a.PointId,
            StartTime: a.Time[0],
            EndTime: a.Time[1],
            DayIndex: v.id + 1,
            Projects: _self.getProjectName(a.PointId),
          });
        });
        _self.detail.lstLineDetails.push(obj);
      });
      ROUTE.updateRoute(_self.detail).then((res) => {
        if (res.status === "success") {
          _self.$message.success("修改成功!");
          //更新仓库路线信息
          _self.$store.dispatch("trip/setRoutes");
          _self.flag = 0;
          _self.getRoutes(); //重新获取数据
        } else {
          _self.$message.error(res.msg);
        }
      });
    },
    resetForm(formName) {
      if (formName === "queryForm") {
        this.query = {
          Name: "",
          StartTime: "",
          EndTime: "",
          PageSize: 10,
          PageIndex: 1,
        };

        this.getRoutes();
      }
    },
    getProjectTime(start, end) {
      let startTime = +start,
        endTime = +end;
      if (isNaN(startTime) || isNaN(endTime)) return [];
      return [
        `${parseInt(startTime / 60)}:${(startTime % 60)
          .toString()
          .padStart(2, "0")} `,
        `${parseInt(endTime / 60)}:${(endTime % 60)
          .toString()
          .padStart(2, "0")}`,
      ];
    },

    //获取单条线路详情
    getDetail(row) {
      var _self=this;
      _self.detail.lineId = row.Id;
      _self.detail.Name = row.Name;
      _self.detail.Describe = row.Describe;
      _self.detail.RestaurantName = row.RestaurantName;
      _self.detail.RestaurantPrice = row.RestaurantPrice;
      _self.detail.AdultPrice = row.AdultPrice;
      _self.detail.ChildrenPrice = row.ChildrenPrice;
      _self.detail.ElderlyPrice = row.ElderlyPrice;
      _self.detail.ProductNumber=row.ProductNumber;
      _self.detail.Status=row.Status;
      _self.loadingLook=true;
      ROUTE.getRouteDetail({ Id: row.Id }).then((res) => {
        if (res.status === "success") {
          if (Array.isArray(res.content.dataAll)) {
            _self.flag = 1;
            _self.table = res.content.dataAll.map((v, i) => {
              return {
                id: i,
                arrangement: [
                  ...v.dataList.map((v) => {
                    return {
                      PointId: v.PointId, //项目Id
                      Projects: v.Projects, //项目名
                      DayIndex: v.DayIndex,
                      Time: _self.getProjectTime(v.StartTime, v.EndTime),
                    };
                  }),
                ],
              };
            });
            _self.timerIndex = _self.table[0].arrangement.length;
            _self.IsOrderCount=res.content.IsOrderCount;
          }
        } else {
          _self.$message.error("线路详情获取失败!");
        }
        _self.loadingLook=false;
      });
    },
    //修改事件
    edit() {
      this.flag = 2;
      this.currentSubId = 0;
    },

    //子表操作
    handleSubtable(type, subId) {
      switch (type) {
        case "plus":
          this.currentSubId = this.table.length;
          // this.timerIndex=this.table[this.table.length].arrangement.length;
          this.table.push({
            id: this.table.length,
            arrangement: [
              {
                PointId: "", //项目Id
                Projects: "", //项目名
                DayIndex: this.table.length + 1,
                Time: ["08:00", "09:00"],
              },
            ],
          });

          break;
        case "minus":
          //  if (this.table.length > 1) {
          //   this.table.pop();
          // } else {
          //   this.$message.error("至少录入一天行程!");
          // }

          if (this.table.length > 1) {
            let index = 0;
            this.table.forEach((item, i) => {
              if (item.id == this.currentSubId) {
                index = i;
                this.table.splice(i, 1);
              }
            });
            this.table.forEach((item, i) => {
              item.id = i;
            });
            if (index > 0) this.currentSubId = this.table[index - 1].id;
            else this.currentSubId = this.table[index].id;
            // this.currentSubId = this.table[index - 1].id;
          } else {
            this.$message.error("至少录入一天行程!");
          }
          break;
        case "switch":
          this.currentSubId = subId;
          this.timerIndex = this.table[subId].arrangement.length;
          break;
        default:
          break;
      }
    },
    //行程安排操作
    handleArrangement(type) {
      var _self = this;
      if (type === "plus") {
        if (_self.linePointFlag.flag) {
          _self.$message.error(
            "第" +
              _self.linePointFlag.day +
              "天的第" +
              _self.linePointFlag.point +
              "个景点时间范围错误请修改"
          );
          return;
        }

        if (
          _self.table[_self.currentSubId].arrangement[
            _self.table[_self.currentSubId].arrangement.length - 1
          ].Time[1] == "23:59"
        ) {
          _self.$message.error("当天行程已满无法继续添加!");
          return;
        }

        if (_self.timerIndex >= 1)
          _self.startTime =
            _self.table[_self.currentSubId].arrangement[
              _self.table[_self.currentSubId].arrangement.length - 1
            ].Time[1];
        _self.timerIndex++;

        let endTime =
          parseInt(_self.startTime.substring(0, 2)) + 1 >= 24
            ? "23:59"
            : parseInt(_self.startTime.substring(0, 2)) + 1 >= 10
            ? parseInt(_self.startTime.substring(0, 2)) + 1 + ":00"
            : "0" + (parseInt(_self.startTime.substring(0, 2)) + 1) + ":00";

        _self.table[_self.currentSubId].arrangement.push({
          PointId: "", //项目Id
          Projects: "", //项目名
          DayIndex: _self.table.length + 1,
          // Time: ["08:00", "09:00"],
          Time: [_self.startTime, endTime],
        });
      } else if (type === "minus") {
        if (_self.table[_self.currentSubId].arrangement.length > 1) {
          _self.timerIndex--;

          _self.startTime =
            _self.table[_self.currentSubId].arrangement[
              _self.table[_self.currentSubId].arrangement.length - 1
            ].Time[1];

          _self.table[_self.currentSubId].arrangement.pop();
        } else {
          _self.$message.error("至少录入一条行程!");
        }
      }
    },
    //删除线路
    deleteRoute(row) {
      ROUTE.deleteRoute({ lineId: row.Id }).then((res) => {
        if (res.status === "success") {
          this.$message.success("删除成功!");
          this.getRoutes();
          this.$store.dispatch("trip/setRoutes");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handlePageSize(value) {
      this.query.PageSize = value;
    },
    handlePageIndex(value) {
      this.query.PageIndex = value;
    },

    getStr(str) {
      var aa = "";
      var bb = "";
      if (str.length == 4) {
        //8:00
        aa = str.substring(0, 1);
        bb = str.substring(str.length, 2);
      } else {
        //10:00
        aa = str.substring(0, 2);
        bb = str.substring(str.length - 2);
      }
      return aa + bb;
    },
  },
  created() {
    this.getRoutes();
  },
  watch: {
    "query.PageSize": function () {
      this.getRoutes();
    },
    "query.PageIndex": function () {
      this.getRoutes();
    },

    table: {
      deep: true,
      handler: function (newVal, oldVal) {
        let _self = this;
        let temp = "";
        _self.linePointFlag = {
          flag: false,
          day: 0,
          point: 0,
        };
        newVal.forEach((i, index) => {
          i.arrangement.forEach((c, count) => {
            if (count == 0) {
              temp = _self.getStr(c.Time[0].trim());
            }

            var vv = _self.getStr(c.Time[0].trim());
            if (parseInt(temp) <= parseInt(vv)) temp = vv;
            else {
              _self.linePointFlag = {
                flag: true,
                day: index + 1,
                point: count + 1,
              };
              return;
            }

            var vvv = _self.getStr(c.Time[1].trim());
            if (parseInt(temp) <= parseInt(vvv)) temp = vvv;
            else {
              _self.linePointFlag = {
                flag: true,
                day: index + 1,
                point: count + 1,
              };
              return;
            }
          });
        });
      },
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
};
</script>

<style scoped lang="less">
.main-left {
  width: 40%;
  min-width: 620px;

  border-right: 1px solid #ddd;
}
.main-left .left-table {
  height: 753px;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-right {
  flex: 1;
}
.right-table {
  padding: 20px;
}
.input-form {
  position: relative;
  width: 95%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.sub-selected {
  background: cornflowerblue;
}
.input-form /deep/ .el-input__inner,
.input-form /deep/ .el-input-number,
.input-form /deep/ .el-select {
  border: none;
  width: 100%;
}

.subtable-tab {
  position: absolute;
  top: 197px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
  // background: red;
}
.subtable-tab .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.subtable-tab .subtable-handle {
  min-width: 100px;
  border-right: 1px solid #aaa;
}
.subtable-tab /deep/ .el-button-group > .el-button {
  width: 50px;
  height: 45px;
  padding: 0;
  font-size: 18px;
  // border: none;
}
</style>
